import { render } from "./ModalConfirmation.vue?vue&type=template&id=5c5c8108&scoped=true"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js"

import "./ModalConfirmation.vue?vue&type=style&index=0&id=5c5c8108&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5c8108"]])

export default __exports__